import bus from 'APP/packages/bus';

import { GroupsEvent } from '../GroupsEvent';

export class BanStatusChanged extends GroupsEvent {
  process() {
    bus.group.broadcastParticipantsChanges(this.groupId);
  }
}
